export default {

    addErroneousElement: (state, action) => {
        const block = action.payload;
        const index = state.findIndex((elm) => elm.blockIndex === block.blockIndex && elm.elmIdx === block.elmIdx);
        if (index < 0) {
            state.push(action.payload);
        }
    },
    deleteErroneousElement: (state, action) => {
        const block = action.payload;
        const index = state.findIndex((elm) => elm.blockIndex === block.blockIndex && elm.elmIdx === block.elmIdx);
        if (index >= 0) {
            state.splice(index, 1);
        }
    },
};
